<template>
  <v-snackbar
    v-model="snack"
    :color="snackEvent !== null ? snackEvent.color : 'success'"
    :timeout="snackEvent !== null ? snackEvent.timeout : 3000"
    :vertical="snackEvent !== null ? snackEvent.vertical : false"
    :top="snackEvent !== null ? snackEvent.top : false"
  >
    {{ snackEvent !== null ? snackEvent.text : '' }}
    <template v-slot:action>
      <v-btn
        dark icon
        @click="snack = false"
      >
        <v-icon>mdi-close-circle-outline</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Snack',
  data() {
    return {
      snack: false,
      snackOptions: {
        text: '',
        color: 'success',
        timeout: 3000,
        vertical: false,
        close: true,
        top: false
      }
    }
  },
  methods: {
    setSnackOptions (
      text,
      color = 'success',
      timeout = 3000,
      vertical = false,
      close = true,
      top = false
    ) {
      this.snackOptions = {
        text: text,
        color: color,
        timeout: timeout,
        vertical: vertical,
        close: close,
        top: top
      }
      this.showSnack()
    },
    showSnack () {
      this.snack = true
    },
  },
  computed: {
    snackEvent() { return this.$store.getters['common/getSnack'] }
  },
  watch: {
    snackEvent(value) {
      if (value && typeof value == 'object') {
        const has = Object.prototype.hasOwnProperty
        this.setSnackOptions(
          value.text,
          value.color,
          value.timeout,
          value.vertical,
          value.close,
          has.call(value, 'top') ? value.top : false
        )
      }
    }
  },
}
</script>

<style lang="sass" scoped>

</style>